<template functional>
  <div
    :class="[data.class, data.staticClass, 'cart-price']"
    :style="[data.style, data.staticStyle]"
    v-bind="data.attrs"
    v-on="listeners"
  >
    <div class="cart-price__regular--wrapper">
      <slot name="regular" v-bind="{ props }">
        <span v-if="props.isShowFromLabel" class="cart-price__from-label">from</span>
        <span
          :class="{ 'display-none': !props.regular || (props.special && props.regular !== props.special) }"
          class="cart-price__regular"
        >
          {{ props.regular }}
        </span>
      </slot>
      <slot name="old" v-bind="{ props }">
        <del :class="{ 'display-none': !props.special || props.regular === props.special }" class="cart-price__old">
          {{ props.regular }}
        </del>
      </slot>
      <slot name="discount">
        <span v-if="props.discount" class="cart-price__discount">{{ props.discount }}% off</span>
      </slot>
    </div>
    <div class="cart-price__special--wrapper">
      <span
        :class="{ 'display-none': !props.special || props.regular === props.special }"
        class="cart-price__special"
      >
        {{ props.special }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CartPrice',
  props: {
    regular: {
      type: [String, Number],
      default: null,
    },
    special: {
      type: [String, Number],
      default: null,
    },
    discount: {
      type: [String, Number],
      default: null,
    },
    isShowFromLabel: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss">
.cart-price {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--sp_4);

  @include for-desktop($s) {
    align-items: flex-end;
  }

  &__regular--wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__regular, &__old, &__special {
    font: 500 16px / 22px var(--font-family--primary);
  }

  &__old {
    color: var(--c-grey-3);
  }

  &__discount {
    align-self: center;
    font: 500 12px / 18px var(--font-family--primary);
    color: var(--c-gold-2);
    min-width: 51px;
    text-align: right;
  }
}
</style>
